import baseAPI from "@/api/base";
import { CONTACTS_NUMBER_INFO_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

export interface UpsertNumberInfoBody {
  contactId: string;
  phoneNumber: string; // E.164
  routeType?: "DIRECT" | "MOBILE" | "IVR" | "GATEKEEPER";
  ivrDigits?: string;
  gatekeeperName?: string;
  isValid?: boolean | null;
}

class ContactNumberInfoService {
  static upsert = async (body: UpsertNumberInfoBody): Promise<AxiosResponse> => {
    return baseAPI.put(CONTACTS_NUMBER_INFO_URL, body);
  };

  static getForContact = async (contactId: string): Promise<AxiosResponse> => {
    return baseAPI.get(`/contact/${contactId}/number-info`);
  };
}

export default ContactNumberInfoService;
